module.exports = __webpack_public_path__ + "img/icone-cassava.5cae9f61.svg";